let targetWrapper = $('.tablist');
let targetMenu = targetWrapper.find('.tablist_menu').find('ul li[data-target]');

if (targetMenu) {
  targetMenu.each((i, item) => {
    $(item).on('click', (e) => {
      e.preventDefault();
      showTab(item);
      history.pushState({}, '', `#${$(item).data('target')}`);
      $([document.documentElement, document.body]).animate({
        scrollTop: $('.tablist_menu').offset().top - 250,
      }, 500);
    })
  })
}




function showTab(tab) {
  if ($(tab).hasClass('current')) {
    return  false
  } else {
    if ($(tab).siblings().hasClass('current')) {
      $(tab).siblings().removeClass('current');
    }
    $(tab).addClass('current');
    let itemShow = targetWrapper.find('#' + $(tab).attr("data-target") );
    itemShow.addClass('current');
    let itemsToHide =  targetWrapper.find('.ttc_wrapper').not(itemShow);
    itemsToHide.removeClass('current');
  }
}

function openTabFromWindowUrl() {
  let hash = window.location.hash;
  if (hash && hash!== "#noscroll") {
      let targetTab = targetWrapper.find('.tablist_menu').find('ul li[data-target=' + hash.substr(1) + ']');
      document.body.scrollTop = false;
      scrollToTab();
      showTab(targetTab);
  }
}

function scrollToTab() {
  let offsetVal = innerWidth < 767 ? 50 : 250;
  $([document.documentElement, document.body]).animate({
    scrollTop: $('.tablist_menu').offset().top - offsetVal,
  }, 500);
}

function postsCarousel() {
  let checkWidth = $(window).width();
  let owlPost = $('.mobileSlider');

  owlPost.each(function(i , elem) {
    if (checkWidth > 767) {

      if (typeof $(elem).data('owl.carousel') != 'undefined')
      {
        $(elem).data('owl.carousel').destroy();
      }
      $(elem).removeClass('owl-carousel');
    }
    else if (checkWidth < 768) {
      $(elem).addClass('owl-carousel');
      $(elem).owlCarousel({
        responsiveClass:true,
        items: 2,
        //navText: ['<span class="icon">'+ dataPrev + '</span>', '<span class="icon">'+ dataNext + '</span>'],
        rewindNav : true,
        nav: false,
        dots: false,
        margin: 32,

      });
    }
  })}
postsCarousel();
if($('main.tech_page').length > 0) {
  openTabFromWindowUrl();
}

$(window).resize(postsCarousel)



// WEBPACK FOOTER //
// ./scripts/tabs.js